import { Text } from "@pushpress/shared-components";
import { useMemo } from "react";
import AppointmentCardV2 from "../AppointmentCardV2/AppointmentCardV2";
import { PlanForm } from "../PlanDrawer.types";
import { type Control, useFieldArray, useWatch } from "react-hook-form";
import { useAppointmentTypesQuery } from "../../../../apis/appointmentApi.hooks";
import { sortByName } from "../../../../utils/sortUtils";
import { AppointmentType } from "../../../../apis/appointmentApi";
import { Button } from "@pushpress/pushpress-ui";

interface AppointmentsSectionProps {
  control: Control<PlanForm>;
}

const AppointmentsSection = (props: AppointmentsSectionProps) => {
  const { control } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "appointmentCredits",
  });

  const [appointmentCredits] = useWatch({
    control,
    name: ["appointmentCredits"],
  });

  const { data: appointmentTypesData } = useAppointmentTypesQuery({
    staleTime: Infinity,
  });

  const appointmentTypes = useMemo(() => {
    if (!appointmentTypesData?.data) {
      return [];
    }
    return [...appointmentTypesData.data].sort(sortByName) as AppointmentType[];
  }, [appointmentTypesData]);


  const filteredAppointmentTypes = useMemo(() => {
    return appointmentTypes.filter(type => !appointmentCredits?.some(credit => credit?.appointmentType?.uuid === type.uuid));
  }, [appointmentCredits, appointmentTypes]);

  return (
    <>
      <Text
        component="h2"
        variant="heading-5"
        weight="600"
        color="wolf-800"
        className="mt-4"
      >
        Appointments
      </Text>
      <Text variant="body-md" color="wolf-600" className="mt-1">
        Add appointment access
      </Text>
      <div className="my-3">
        {fields.map((field, index) => (
          <AppointmentCardV2
            key={index}
            appointmentCredits={fields}
            control={control}
            remove={remove}
            idx={index}
          />
        ))}
      </div>
      {filteredAppointmentTypes?.length > 0 && (<Button
        variant="outline"
        onClick={() => append({
          appointmentType: filteredAppointmentTypes[0],
          quantity: 1,
          expirationDays: 30,
        })}
      >
        + Add additional appointment credits
      </Button>
      )}
    </>
  );
};

export default AppointmentsSection;
